/**
 * Wait for an element before resolving a promise
 * @param {String} querySelector - Selector of element to wait for
 * @param {Number} timeout - Milliseconds to wait before timing out, or 0 for no timeout              
 */
export const waitForElement = (querySelector: string, timeout: number, observee?:string) => {
    let timer: NodeJS.Timeout;
    return new Promise((resolve, reject) => {
        if (document.querySelector(querySelector)) return resolve(document.querySelector(querySelector));
        const observer = new MutationObserver(() => {
            if (document.querySelector(querySelector)) {
                observer.disconnect();
                if (!timer) clearTimeout(timer);
                return resolve(document.querySelector(querySelector));
            }
        });
        observer.observe(observee?document.querySelector(observee)??document.body:document.body, {
            childList: true,
            subtree: true
        });
        if (timeout) timer = setTimeout(() => {
            observer.disconnect();
            reject();
        }, timeout);
    });
}